import { List } from "immutable";
import { IAnalyticEventData } from "common/records/AnalyticEvent";
import { AnalyticsReportDataRecord } from "common/records/AnalyticsReport";
import { AnalyticsUserRecord } from "common/records/AnalyticsUser";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

// Analytics Events (History)
export const RECEIVE_ANALYTIC_EVENT = "@analytics/RECEIVE_ANALYTIC_EVENT";
export const RECEIVE_ANALYTIC_EVENTS = "@analytics/RECEIVE_ANALYTIC_EVENTS";

// Analytics Reports
export const FETCH_ANALYTICS_REPORT = "@analytics/FETCH_ANALYTICS_REPORT";
export const RECEIVE_ANALYTICS_REPORTS = "@analytics/RECEIVE_ANALYTICS_REPORTS";
export const SET_ANALYTICS_REPORT_LOADED = "@analytics/SET_ANALYTICS_REPORT_LOADED";
export const CLEAR_ANALYTICS_REPORTS = "@analytics/CLEAR_ANALYTICS_REPORTS";

// Analytics Users (separate from main user state)
export const FETCH_ANALYTICS_USER = "@analytics/FETCH_ANALYTICS_USER";
export const RECEIVE_ANALYTICS_USER = "@analytics/RECEIVE_ANALYTICS_USER";
export const SET_ANALYTICS_USER_FAILED = "@analytics/SET_ANALYTICS_USER_FAILED";
export const CLEAR_ANALYTICS_USERS = "@analytics/CLEAR_ANALYTICS_USERS";

export const AnalyticsActions = {
  // Analytics Events (History)
  receiveAnalyticEvent: (analyticEvent: Partial<IAnalyticEventData>) =>
    createAction(RECEIVE_ANALYTIC_EVENT, { analyticEvent }),
  receiveAnalyticEvents: (analyticEvents: Partial<IAnalyticEventData>[]) =>
    createAction(RECEIVE_ANALYTIC_EVENTS, { analyticEvents }),

  // Analytics Reports
  fetchAnalyticsReport: (jobId: number) => createAction(FETCH_ANALYTICS_REPORT, { jobId }),
  receiveAnalyticsReports: (reports: List<AnalyticsReportDataRecord>) =>
    createAction(RECEIVE_ANALYTICS_REPORTS, { reports }),
  setAnalyticsReportLoaded: () => createAction(SET_ANALYTICS_REPORT_LOADED),
  clearAnalyticsReports: () => createAction(CLEAR_ANALYTICS_REPORTS),

  // Analytics Users
  fetchAnalyticsUser: (userId: number) => createAction(FETCH_ANALYTICS_USER, { userId }),
  receiveAnalyticsUser: (userId: number, user: AnalyticsUserRecord) =>
    createAction(RECEIVE_ANALYTICS_USER, { userId, user }),
  setAnalyticsUserFailed: (userId: number, user: AnalyticsUserRecord) =>
    createAction(SET_ANALYTICS_USER_FAILED, { userId, user }),
  clearAnalyticsUsers: () => createAction(CLEAR_ANALYTICS_USERS),
};

export type AnalyticsActions = ActionsUnion<typeof AnalyticsActions>;
